import { render, staticRenderFns } from "./ModalTag.vue?vue&type=template&id=113e6a4e"
import script from "./ModalTag.vue?vue&type=script&lang=js"
export * from "./ModalTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports